import api from '@/api';

const resource = 'atena/tela-subgrupo';

export default {
  getTelaSubGrupo(id) {
    return api.get(`${resource}/${id}`);
  },
  postTelaSubGrupo(data) {
    return api.post(`${resource}`, data);
  },
  putTelaSubGrupo(data) {
    return api.put(`${resource}/${data.identificadortelasubgrupo}`, data);
  },
  deleteTelaSubGrupo(id) {
    return api.delete(`${resource}/${id}`);
  },
  getSelectTelaSubGrupo() {
    return api.get(`${resource}/select`);
  },
};
